function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M438.973,411.718c-14.598,0-26.475,11.876-26.475,26.475c0,14.598,11.876,26.474,26.475,26.474 c14.598,0,26.474-11.876,26.474-26.474C465.447,423.595,453.571,411.718,438.973,411.718z M438.972,448.977 c-5.946,0-10.784-4.838-10.784-10.784c0-5.946,4.838-10.784,10.784-10.784c5.946,0,10.784,4.838,10.784,10.784 S444.918,448.977,438.972,448.977z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M510.303,436.82c-0.5-19.383-8.704-37.211-23.102-50.198L329.249,244.157l139.658-139.658 c0.918-0.274,1.825-0.615,2.7-1.077L501.85,87.46c4.178-2.206,6.98-6.152,7.685-10.823c0.706-4.672-0.805-9.268-4.146-12.612 l-34.052-34.051c-3.342-3.341-7.935-4.852-12.611-4.146c-4.671,0.705-8.616,3.507-10.823,7.686L431.94,63.755 c-0.466,0.883-0.824,1.796-1.099,2.723l-65.92,65.92c-3.064,3.065-3.064,8.031,0,11.096c3.065,3.062,8.031,3.062,11.096,0 l60.492-60.493l15.853,15.853l-154.7,154.7l-15.853-15.853l67.525-67.524c3.064-3.065,3.064-8.031,0-11.096 c-3.065-3.062-8.031-3.062-11.096,0l-48.994,48.994l-53.322-48.094c15.118-43.516,4.17-91.931-28.625-124.725 C173.706,1.665,123.314-9.04,78.916,7.987c-2.481,0.952-4.312,3.094-4.864,5.693s0.247,5.301,2.126,7.18l61.592,61.593 c1.822,1.822,2.827,4.245,2.827,6.822c0,2.577-1.004,5-2.827,6.823l-39.999,39.999c-1.822,1.823-4.245,2.827-6.822,2.827 c-2.577,0-5-1.003-6.823-2.827L22.533,74.504c-1.88-1.879-4.58-2.678-7.18-2.126c-2.599,0.553-4.741,2.383-5.693,4.864 c-17.027,44.396-6.322,94.788,27.27,128.381c31.991,31.99,79.468,43.253,122.299,29.414l41.227,45.083 c-1.981,3.871-4.557,7.481-7.734,10.658c-11.884,11.884-29.695,15.628-45.38,9.54c-2.899-1.128-6.188-0.434-8.388,1.765 l-96.059,96.059c-26.004,26.005-26.004,68.317,0,94.32C55.494,505.063,72.243,512,90.058,512c17.814,0,34.564-6.937,47.161-19.534 l96.059-96.058c2.198-2.199,2.891-5.489,1.765-8.388c-6.089-15.684-2.345-33.497,9.538-45.381 c11.886-11.884,29.698-15.628,45.382-9.54c2.901,1.128,6.188,0.432,8.388-1.765l18.12-18.12c5.456-5.456,8.46-12.711,8.46-20.426 c0-7.715-3.004-14.97-8.46-20.426l-7.713-7.713l9.383-9.383l158.552,143.007c11.172,10.077,17.539,23.911,17.926,38.951 c0.387,15.04-5.259,29.183-15.898,39.821c-10.588,10.59-24.695,16.226-39.636,15.903c-14.971-0.334-28.781-6.604-38.886-17.655 L282.31,346.378c-2.927-3.199-7.887-3.419-11.084-0.495c-3.197,2.925-3.419,7.887-0.495,11.084l117.888,128.915 c13.024,14.241,30.822,22.321,50.115,22.752c0.54,0.012,1.079,0.018,1.618,0.018c18.688,0,36.199-7.249,49.464-20.512 C503.526,474.429,510.801,456.203,510.303,436.82z M446.149,70.45l15.019-28.454l32.199,32.199l-28.454,15.019L446.149,70.45z  M167.324,220.639c-2.16-2.36-5.534-3.174-8.532-2.056c-38.363,14.31-81.845,4.868-110.768-24.052 c-26.262-26.263-36.438-64.337-27.471-99.815l52.477,52.477c4.787,4.786,11.15,7.421,17.918,7.421s13.131-2.635,17.917-7.421 l39.999-39.999c4.786-4.787,7.421-11.15,7.421-17.918s-2.635-13.131-7.421-17.917L96.388,18.88 c35.475-8.971,73.553,1.208,99.814,27.471c29.659,29.657,38.773,74.003,23.222,112.978c-1.217,3.049-0.407,6.534,2.032,8.733 l56.679,51.122l-7.422,7.422L263,218.893c-5.456-5.456-12.711-8.46-20.426-8.46c-7.715,0-14.97,3.004-20.426,8.46l-18.12,18.12 c-2.198,2.199-2.891,5.489-1.765,8.388c2.087,5.375,2.992,10.997,2.837,16.548L167.324,220.639z M305.374,302.119l-14.682,14.683 c-20.192-5.821-42.164-0.299-57.205,14.741h-0.001c-15.04,15.041-20.563,37.01-14.74,57.206l-92.622,92.62 c-9.634,9.634-22.442,14.94-36.065,14.94s-26.433-5.306-36.065-14.94c-19.887-19.886-19.887-52.244,0-72.131l92.621-92.621 c20.194,5.824,42.163,0.298,57.205-14.742c15.04-15.041,20.564-37.01,14.741-57.205l14.683-14.682 c5.144-5.146,13.517-5.146,18.661,0l13.261,13.261l26.947,26.947l13.261,13.261C310.52,288.603,310.52,296.975,305.374,302.119z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M162.326,346.249c-3.065-3.063-8.031-3.063-11.096,0l-74.318,74.318c-3.064,3.065-3.064,8.031,0,11.096 c1.532,1.531,3.541,2.297,5.548,2.297c2.007,0,4.016-0.766,5.548-2.297l74.318-74.318 C165.389,354.28,165.389,349.313,162.326,346.249z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M189.785,373.708c-3.064-3.063-8.031-3.063-11.096,0l-74.318,74.317c-3.064,3.065-3.064,8.031,0,11.096 c1.532,1.531,3.54,2.297,5.548,2.297c2.007,0,4.016-0.766,5.548-2.297l74.318-74.317 C192.849,381.739,192.849,376.773,189.785,373.708z"
})));

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var SvgAppliancesInstallationRepair = function SvgAppliancesInstallationRepair(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAppliancesInstallationRepair, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appliances-installation-repair.b4625733.svg";
export { ForwardRef as ReactComponent };